export var appUrlsMapping = {
    base: 'app',
    helpCenterBase: 'hc',
    helpDeskBase: 'helpdesk',
    insightsBase: 'insights',
    settingsBase: 'settings'
};
//# sourceMappingURL=urls-mapping.const.js.map